import i18next from "i18next";
import {LocaleJa as ja} from '../locales/ja'
import {LocaleEn as en} from '../locales/en'

i18next.init({
  fallbackLng: 'ja',
  lng: document.documentElement.lang,
  resources: {
    ja: {translation: ja},
    en: {translation: en}
  }
});

export default i18next;
